module.exports = __webpack_public_path__ + "assets/headspace-9a614fdc43bf4962d8370a463f3722e3.png";